export const nonSelectedMenuItemStyle = {
  '&.Mui-selected': {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'action.hover',
    },
  },
};

const MuiMenuItem = {
  styleOverrides: {
    root: {},
  },
};

export default MuiMenuItem;

